import {
  cloudComputing,
  devSecOps,
  productEngineering,
  qualityAssuranceAutomation,
  strategicConsulting,
} from "../assets";


export const servicesContent = [
  {
    key: "strategic-consulting",
    title: "Strategic Consulting",
    intro:
      "Analyzing business practices and goals and make suggestions for improvements or company direction.",
    accordian_heading: "Our Strategic Consulting Capabilities",
    banner_img: { strategicConsulting },
    content: [
      {
        key: "1",
        label: "Digital and Omni-channel excellence",
        children: (
          <p>
            We are your strategic partner in unified commerce, and have
            unparalleled experience working with leading retailers and brands to
            develop and deliver their omni-channel strategies, including
            adoption of agile methodologies to pace up innovation.
          </p>
        ),
        showArrow: false,
      },
      {
        key: "2",
        label: "Omni-Channel Best Practices Review",
        children: (
          <p>
            There is no doubt that social and mobile technologies are profoundly
            changing consumers’ shopping habits and expectations, and the pace
            of change is impressive. Brands must catch up with omni-channel
            consumers. Your brand requires building customer loyalty across
            different sales channels. You need to be cutting-edge about it and
            refine your practices to beat competition and cater to modern day
            consumers who exhibit complex shopping behaviors. Let’s review such
            practices.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Data analytics",
        children: (
          <p>
            As data explodes in quantity and complexity companies find it
            increasingly difficult to unlock its full potential. We take a
            comprehensive approach for your data challenges.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Custom strategy",
        children: (
          <p>
            For starters we engage in understanding of your retail environment
            and identifying areas for improvement. We leverage your existing
            resources to control costs and incorporate future-forward technology
            and strategies that will maximize your ROI, build long-term growth,
            and help you remain relevant.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "5",
        label: "Data-driven enterprise",
        children: (
          <p>
            Unlock the value of data, architecture, and AI to drive business
            agility and transformation to a real-time enterprise.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "6",
        label: "Resilient modern architecture",
        children: (
          <p>
            Exploit technology and modern architectures as critical enablers of
            business growth.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "7",
        label: "Retail Consulting and Expertise",
        children: (
          <p>
            Retailing is more competitive than ever before with disruptive new
            entrants and channel blurring. The pace of market change has
            continued to accelerate in terms of shopper needs, formats, rising
            costs and government legislation. Technologies including digital,
            big data, robotics and smart logistics are transforming, growing and
            destroying retail companies. Retail strategy must identify where to
            play and how to win during this wave of industry transformation. Our
            team acts as an extension of yours, working with you to develop
            strategies for attracting new shoppers, increasing retention, easing
            processes, and boosting sales. We provide key resources to focus on
            technology so you can focus on your customers.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "8",
        label: "Future-proofing",
        children: (
          <p>
            Technologies move fast. Our team helps you adapt and evolve,
            implementing technology that increases your efficiency and organizes
            valuable information about your customers, and inventory that helps
            you make smarter business decisions.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "9",
        label: "Technology Consulting",
        children: (
          <p>
            Our approach is centered around enabling your organization to
            achieve predictable delivery of business value and avoid the
            constant churn that plague most organizations.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "10",
        label: "Cloud acceleration",
        children: (
          <p>
            We bring our industry expertise to solve your unique needs. With our
            extensive experience within the team we bring global and local
            knowledge to each engagement. We use the cloud to re-imagine
            technology delivery, business models and revenue streams.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "11",
        label: "Agile Transformation Consulting",
        children: (
          <p>
            Using Agile thinking, we can help you revive stalled digital
            projects and accelerate completion of your other digital priorities.
            We have a proven method for transforming companies into truly Agile
            enterprises and propelling Agile transformations.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "12",
        label: "Digital Transformation Strategy Consulting",
        children: (
          <p>
            A winning digital strategy balances today’s needs with tomorrow’s
            opportunities. Our strategy combines our industry-leading experience
            with advanced analytic, powerful digital tools, a vast array of
            complementary capabilities and an extensive ecosystem of
            best-of-breed partners to help you win today and in the future.
          </p>
        ),
        showArrow: false,

      },
    ],
  },
  {
    key: "digital-product-engineering",
    title: "Digital Product Engineering",
    intro:
      "We deliver custom agile product development solutions across industry domains, leveraging web, mobile and cloud technologies.",
    accordian_heading: "Our Product Engineering capabilities",
    banner_img: { productEngineering },
    content: [
      {
        key: "1",
        label: "Product Consulting and Strategy",
        children: (
          <p>
            Our core team will redefine your success with powerful software
            products. They will use the latest technologies to provide you with
            customized solutions that address your business challenges. We
            understand that developing efficient IT products requires different
            perspectives and knowledge. Hence, we combine our expertise with
            experience to offer unique product development solutions.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "2",
        label: "Product Architecture",
        children: (
          <p>
            Our core team assists in defining the performance, security,
            quality, and other aspects of the software before it is developed.
            Our team analysis the blueprint for language, framework, design,
            platform, compatibility, security, and more to ensure the best
            outcome. We affirm that with our rich experience and proven skills,
            we support you with the enriching choices.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Product Design & UX",
        children: (
          <p>
            Our UI/UX engineers are responsible for attractive and engaging
            visual designs on a website or app to ensure better user engagement.
            The responsive designs are achieved by using CSS, HTML and other
            tools. It includes structuring all the elements of the platform
            appropriately. UI, on the other hand, is the user interface
            development, a process for a flawless presentation and interactivity
            of the portal. We promote an intuitive and easy navigation system
            for the website or app, resulting in a higher number of users and
            engagement.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "4",
        label: "Application Engineering",
        children: (
          <p>
            Applications engineering forms a crucial link between customers and
            the executive team. Our core team have in-depth understanding of
            engineering principles and development processes and have excellent
            communication skills apt to work directly with customers to
            understand their specific technical requirements and ensure meeting
            them.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "5",
        label: "Enterprise Integration",
        children: (
          <p>
            Our core team is involved in setting the product implementation
            guidelines, product customization we also adopt the latest trends in
            tools and technologies. We do take the responsibilities for
            developing and implementing templates, frameworks, standards,
            reusable components to enable efficient implementation and faster
            turnaround for time critical projects.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "6",
        label: "Product Quality Engineering",
        children: (
          <p>
            In order to achieve quality in product deliveries we provide Product
            Testing Services across the entire product life-cycle. Our services
            offer on-demand, scalable and cost effective product testing
            services to reduce cycle time while maintaining the highest product
            quality. Our rich testing experience, processes, tools and
            automation frameworks deliver unparalleled service.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "7",
        label: "Support & Maintenance",
        children: (
          <p>
            Our processes and teams have been built on a foundation that begins
            with the idea of a proactive approach to software support and
            maintenance. Our methodologies and systems focus on consistent
            stability, long-term functionality, and rigorous preventive
            maintenance to avoid problems that typically arise from less than
            complete or short-term solutions. Our core team rapidly diagnoses
            and resolves technical problems, as well as proactively plan for
            future support, with the goal of reducing your long-term maintenance
            costs. We support our customers with effective tools, technologies
            and processes enabling them to focus on newer initiatives and ensure
            an ongoing happy customer base.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "8",
        label: "Product Enhancement",
        children: (
          <p>
            We regularly advance our product features and quality within minimal
            time-frame. With our extensive product engineering solutions, we
            work closely with customers to understand their product nuances and
            market dynamics and provide recommendations for product enhancement.
            We provide Product gap analysis and conceptualization, Product
            roadmap and architecture, Product transition, Environment upgrades,
            Web, SaaS and Mobile enablement.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "9",
        label: "Legacy Transformation",
        children: (
          <p>
            Our product development solutions ensure smooth and optimized
            migration of the products from legacy technology to new technology
            platforms. We follow best-in-class technology practice for both
            legacy application migration and data migration. Our legacy
            transformation services includes Product transition planning, Design
            and re-architecture, Re-engineering services, Develop migration
            strategies, Application, Data and Database Migration.
          </p>
        ),
        showArrow: false,

      },
    ],
  },
  {
    key: "devsecops",
    title: "DevSecOps",
    intro:
      "Our team produces customized DevSecOps platforms, integrating security into areas such as build automation, test automation, deployment automation, monitoring, environment management and others.",
    accordian_heading: "Our DevSecOps Capabilities",
    banner_img: { devSecOps },
    content: [
      {
        key: "1",
        label: "DevSecOps Maturity Assessment",
        children: (
          <p>
            With proper measure of an organization’s IT, we implement the
            DevSecOps theories. Our assessment tools can help you identify gaps
            in processes or technologies and provide reports on other areas
            vital to your DevSecOps journey. Get a full business picture on
            culture, automation, measure, and sharing.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "2",
        label: "Integrate Security into DevOps Practices",
        children: (
          <p>
            DevSecOps approach automates tests, reducing potential security
            risks. It also provides benefits in terms of consistency and
            predictability.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Identify Gaps in Culture, People & Process",
        children: (
          <p>
            We understand where your gaps are in terms of processes,
            technologies and working locations and accordingly we join together
            to fulfill your goals.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "4",
        label: "Accelerate DevSecOps Tools Selection",
        children: (
          <p>
            Automation is at the Heart of the DevSecOps Approach. Organizations
            that want to deliver value early and often should adopt tools and
            practices that unite application development, IT operations, QA
            testing, and security teams under a common DevSecOps rubric. We’ve
            put together a list of some of the top DevSecOps tools that
            organizations can integrate into their DevOps pipeline, to ensure
            that security is handled continuously throughout the development
            lifecycle.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "5",
        label: "DevSecOps Implementation",
        children: (
          <p>
            We can help you implement DevSecOps for better collaboration, faster
            time to market, enhanced customer satisfaction, and improved
            productivity without leaving you open to threats and
            vulnerabilities.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "6",
        label: "Infrastructure Automation",
        children: (
          <p>
            Our infrastructure automation solution is based on the
            ‘Infrastructure as a Code’ and ‘Configuration as a Code’ approaches
            and ensures your infrastructure is up and running fast.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "7",
        label: "SAST & DAST",
        children: (
          <p>
            Static Application Security Testing (SAST) and Dynamic Application
            Security Testing (DAST) tools provide a complementary security
            approach with static tests, before or during compiling the code as
            well as dynamic tests after the code is compiled.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "8",
        label: "Site Reliability Engineering",
        children: (
          <p>
            Our proven methodology and accelerators help organizations setup SRE
            operations quickly. Our DevOps and SRE practice accelerators ensure
            your live services are up and running round the clock.
          </p>
        ),
        showArrow: false,

      },
    ],
  },
  {
    key: "quality-assurance-automation",
    title: "Quality Assurance Automation",
    intro:
      "Our Quality team always suggests to transform the testing to ensure the highest quality at all times.",
    accordian_heading: "Our Quality Assurance Automation Capabilities",
    banner_img: { qualityAssuranceAutomation },
    content: [
      {
        key: "1",
        label: "Distributed Agile Testing Framework",
        children: (
          <p>
            Our quality engineering and agile expertise ensures continuous
            integration and implementation of testing techniques so that
            software testing could complement development and also prove in the
            early adoption of test automation. This approach optimizes
            time-to-market and also prevents from defect slippage.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "2",
        label: "Quality Engineering for Agile Transformation",
        children: (
          <>
            <p>
              For Agile transformation of quality assurance, we believe that
              testing calls for hand in hand with the development.
            </p>
            <p>
              The major need of testing such as clear acceptance and DONE
              criteria, proper effort estimation for testing should be
              considered during sprint planning phase.
            </p>
          </>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Agile Testing Process at Clover Bay",
        children: (
          <p>
            Clover Bay delivers Agile Testing services through a seeded process
            that begins with Sprint planning and ends with Execution, our Core
            team works toward achieving true agility and helps in identifying
            defects, eliminating redundancy and strengthening QA.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "4",
        label: "Quality Gates",
        children: (
          <p>
            Quality Gates are an inherent part of Clover Bay’s Agile Testing
            framework. Our quality gates hold pre-built policies & criteria that
            is customized based on client needs.{" "}
          </p>
        ),
        showArrow: false,

      },
      {
        key: "5",
        label: "Collaboration",
        children: (
          <p>
            Our QA team collaborates closely with the development and Ops team.
            An optimum mix of co-location and offshoring is deployed to ensure
            effective collaboration and cost efficiencies. The QA team also
            participates in all agile testing ceremonies including daily
            stand-up meetings through to various tools for better communication
            and transparency.
          </p>
        ),
        showArrow: false,

      },
    ],
  },
  {
    key: "cloud-computing",
    title: "Cloud Computing",
    intro:
      "Our cloud solutions enable organizations to reduce IT resource requirements and improve productivity, in addition to lowering costs and reducing the time-to-market.",
    accordian_heading: "Our Cloud Computing Capabilities",
    banner_img: { cloudComputing },
    content: [
      {
        key: "1",
        label: "Consultation Services",
        children: (
          <p>
            We offer our consultancy in cloud readiness assessment, architecture
            audit, creating road-maps and strategy, we also extend our
            recommendations for multi-cloud strategy and fitment analysis.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "2",
        label: "Cloud Migration and Modernization",
        children: (
          <p>
            For Cloud migration and modernization our team starts with the SWOT
            analysis following with the readiness assessment, post which
            cloud-to-cloud movement and migration of workloads are executed. In
            the last phase we do validation and performance testing.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "3",
        label: "Disaster Recovery Management Services",
        children: (
          <p>
            In this service our team is capable by assisting with the
            application protection, remote management of all backups and also
            customized disaster recovery plans.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "4",
        label: "Monitoring Services",
        children: (
          <p>
            We also provide the cloud-based application monitoring, along with
            creation of personalized parameters and checks and setting up
            personalized alerts
          </p>
        ),
        showArrow: false,

      },
      {
        key: "5",
        label: "Cloud Infrastructure Management",
        children: (
          <p>
            Our Cloud team can end to end take care of cloud data center design,
            development, and implementation, including deployment of cloud
            infrastructure and application as well as operations management.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "6",
        label: "Cloud App Development",
        children: (
          <p>
            Our Cloud App development team will design, launch and maintain
            applications that will run on a Cloud environment. They will also
            take care of all benefits of Cloud computing such as agility,
            flexibility, data security, and data integrity.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "7",
        label: "Cloud Integration",
        children: (
          <p>
            Our Cloud integration services will enable your organization to
            integrate various systems, tools, applications, processes, and
            platforms with Cloud, so that your business can witness the impact
            of real-time data exchange, data security, cross-platform
            accessibility, and more benefits.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "8",
        label: "Cloud Security",
        children: (
          <p>
            If your looking to improvise your cloud security process, you are at
            right place as our Cloud Security consultants will evaluate your
            existing Cloud platform, discover the loopholes and suggest the
            best, most formidable Cloud security that will cover all the
            loopholes and vulnerabilities.
          </p>
        ),
        showArrow: false,

      },
      {
        key: "9",
        label: "DevOps",
        children: (
          <p>
            We provide with the process automation, CI/CD, continuous
            monitoring, and continuous testing. We also serve for code
            development pipeline as well as infrastructure.
          </p>
        ),
        showArrow: false,

      },

    ],
  },
];
